/**
 * Reports engine layout guard — Layer 3 of the module gate (ADR-0046).
 *
 * The config-driven Reports engine is a 1.0-withheld module (returns in 1.2).
 * This layout route redirects a typed `/reports` URL — and nested children
 * (`/reports/new`, `/reports/$reportKey`) — to `/` unless the workspace is
 * entitled to `reports`, which no 1.0 plan grants. The kept dashboard's
 * analytics use separate server procedures (`reports.aging`) that stay open.
 * Renders only an `<Outlet/>`. @see docs/adr/0046-withheld-1.0-modules.md
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireModule } from "../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/reports")({
  beforeLoad: requireModule("reports"),
  component: Outlet,
});
